<mat-card>
  <mat-card-content>
    <div class="title p-b-20">
      <div>
        Discover the full capabilities on our <a target="_blank" href='/docs/situview'>Developer Documentation</a>
        page.
      </div>
    </div>
    <mat-tab-group dynamicHeight [(selectedIndex)]="selectedIndex">
      <mat-tab [disabled]="disableControls">
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">home</mat-icon>
          Viewer
        </ng-template>
        <div id="layout" class="p-t-20">
          <div class="container" fxLayout="column" fxLayoutAlign="start center">
            <div id="panorama">
              <div [id]="_panoramaOverlay">
                <div id="panorama-controls" [hidden]="hideControls">
                  <div [hidden]="hideControls">
                    <button [disabled]="disableControls" mat-button (click)="toggleFullscreen()" matTooltip="Open/Close Fullscreen"
                            [matTooltipPosition]="'below'">
                      <mat-icon class="icon-display" aria-hidden="false" aria-label="fullscreen">
                        fullscreen
                      </mat-icon>
                    </button>
                    <button [disabled]="disableControls || !deviceHasGyro" mat-button (click)="toggleGyro()" matTooltip="{{gyroTooltip}}" [matTooltipPosition]="'below'">
                      <mat-icon class="icon-display" aria-hidden="false" aria-label="toggleGyro">
                        3d_rotation
                      </mat-icon>
                    </button>
                    <button [disabled]="disableControls" mat-button [class.selected]="showFloorPlan" (click)="toggleFloorPlan()" matTooltip="Toggle Floorplan" [matTooltipPosition]="'below'">
                      <mat-icon class="icon-display" aria-hidden="false" aria-label="toggleFullscreenPanel">
                        map
                      </mat-icon>
                    </button>
                    <button [disabled]="disableControls" mat-button (click)="copyDebugUrl()" matTooltip="Share this location" matTooltipPosition="below">
                      <mat-icon class="icon-display" aria-hidden="false" aria-label="shareLocation">
                        share_location
                      </mat-icon>
                    </button>
                    <button [disabled]="disableControls" mat-button (click)="urlToClipboard()" matTooltip="Copy URL to clipboard.">
                      {{viewingAngleForDisplay}}°
                    </button>
                    <button [disabled]="disableControls" *ngIf="advancedEnabled" mat-button (click)="toggleAdvancedOptions()" matTooltip="Advanced">
                      <mat-icon class="icon-display">
                        code
                      </mat-icon>
                    </button>
                  </div>
  
                  <div *ngIf="advancedEnabled" [hidden]="!advancedVisible">
                    <h3>Advanced Items</h3>
                    <div *ngIf="this.PluginManager">
                      Fullscreen: {{this.PluginManager.isFullScreen()}}<br />
                      Gyroscope enabled: {{this.PluginManager.isGyroEnabled()}}</div>
                    <hr />
                    <div>
                      <button mat-button (click)="this.PluginManager.toggleFullScreen()">Toggle
                        Fullscreen</button>
                      <button mat-button (click)="this.PluginManager.openFullScreen()">Open
                        Fullscreen</button>
                      <button mat-button (click)="this.PluginManager.closeFullScreen()">Close
                        Fullscreen</button>
                    </div>
                    <div>
                      <button mat-button (click)="this.PluginManager.toggleGyro()">Toggle
                        Gyro</button>
                      <button mat-button (click)="this.PluginManager.enableGyro()">Enable
                        Gyro</button>
                      <button mat-button (click)="this.PluginManager.disableGyro()">Disable
                        Gyro</button>
                    </div>
                  </div>
                  <div id="panorama-overlay-floorplan" [style.opacity]="!showFloorPlan ? '0' : '1'"
                    [style.visibility]="!showFloorPlan ? 'hidden' : 'visible'">
                    <button class="floorplan-pin" mat-icon-button (click)="toggleFloorLock()" matTooltip="Pin"
                      [matTooltipPosition]="'below'" [class.pin-angled]="!floorPlanLocked">
                      <mat-icon aria-hidden="false" aria-label="Pin">
                        push_pin
                      </mat-icon>
                    </button>
                    <div>
                      <button mat-button (click)="switchFloorPlan(0)" *ngIf="floorPlansAvailable.indexOf('GROUND') > -1" [class.selected]="!!floors[0]">
                        Ground
                      </button>
  
                      <button mat-button (click)="switchFloorPlan(1)" *ngIf="floorPlansAvailable.indexOf('FIRST') > -1" [class.selected]="!!floors[1]">
                        First
                      </button>
  
                      <button mat-button (click)="switchFloorPlan(2)" *ngIf="floorPlansAvailable.indexOf('SECOND') > -1" [class.selected]="!!floors[2]">
                        Second
                      </button>
                    </div>
                    <app-floor-plan [interactive]="true" [floor]="'GROUND'"
                      [hidden]="floorPlansAvailable.indexOf('GROUND') == -1 || !floors[0]"
                      [onPluginManagerLoad]="pluginManagerLoaded" [floorplanSettings]="smallFloorplanSettings"
                      [interactive]="floorplanInteractive">
                    </app-floor-plan>
  
                    <app-floor-plan [interactive]="true" [floor]="'FIRST'"
                      [hidden]="floorPlansAvailable.indexOf('FIRST') == -1 || !floors[1]"
                      [onPluginManagerLoad]="pluginManagerLoaded" [floorplanSettings]="smallFloorplanSettings"
                      [interactive]="floorplanInteractive">
                    </app-floor-plan>
  
                    <app-floor-plan [interactive]="true" [floor]="'SECOND'"
                      [hidden]="floorPlansAvailable.indexOf('SECOND') == -1 || !floors[2]"
                      [onPluginManagerLoad]="pluginManagerLoaded" [floorplanSettings]="smallFloorplanSettings"
                      [interactive]="floorplanInteractive">
                    </app-floor-plan>
  
                    <div *ngIf="!floorPlansAvailable.length && !showLoading">
                      No floorplan to display.
                    </div>
                    <div *ngIf="!floorPlansAvailable.length && showLoading">
                      Loading...
                    </div>
                  </div>
                </div>
                <div id="panorama-loading-progress">
                  <div *ngIf="showLoading" class="loading-overlay">
                    <div *ngIf="loadingSplash != null" class="loading-splash">
                      {{loadingSplash}}
                    </div>
                  </div>
                  <div id="right-align" *ngIf="showLoading">
                    <div>
                      <mat-spinner [diameter]="40">
                      </mat-spinner>
                      <div class="loading-value">
                        {{loadingValue}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="error && !showLoading && !firstRoomLoaded" class="viewer-loading" fxLayout="row" fxLayoutAlign="center center">
                <div class="text-danger">{{ error }}</div>
              </div>
              <div *ngIf="showLoading && !firstRoomLoaded" class="viewer-loading" fxLayout="row" fxLayoutAlign="center center">
                <div>loading your home...<span *ngIf="loadingValue" class="highlight">{{ (loadingSplash ? loadingSplash : '') }} {{ loadingValue }}%</span></div>
              </div>
              <div *ngIf="noHomes && !showLoading && !firstRoomLoaded && !error" class="viewer-loading" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <div>no homes to load...</div>
                <button
                  [@cardAnimator]="animateAddHome"
                  (@cardAnimator.done)="animateAddHome = ''" 
                  matTooltip="Add Home to get started!"
                  mat-flat-button color="accent"
                  (click)="onClickAddHome()">
                  <mat-icon>add</mat-icon> Add Home
                </button>
              </div>
              <app-panorama [hidden]="disableControls || error || noHomes || !firstRoomLoaded"
                [onPluginManagerLoad]="pluginManagerLoaded"
                [onLoadHome]="onLoadHome"
                [builder]="company?.code"
                [home]="selectedHomeConfig?.home"
                [themes]="selectedHomeConfig?.themes"
                [options]="selectedHomeConfig?.options"
                [startingRoom]="selectedHomeConfig?.room"
                [viewAngle]="selectedHomeConfig?.viewingAngle"
                [masterFile]="selectedHomeConfig?.masterFile"
                [overlayElementID]="_panoramaOverlay"
                [env]="selectedHomeConfig?.environment"
                [render]="selectedHomeConfig?.render"
                (viewingAngle)="setViewAngle($event)"
                (error)="alertError($event)">
              </app-panorama>
            </div>
            <div class="p-t-15">
              <div id="button-array" fxLayout="row wrap" class="shortcut-list">
                <button mat-flat-button *ngFor="let item of shortCuts"
                  [color]="item?.historic ? 'primary' : 'accent'"
                  matTooltipClass="multiline-tooltip"
                  [matTooltip]="getTooltip(item)"
                  [disabled]="disableControls"
                  (click)="loadShortCuts(item)">
                    {{item.home}}
                    <small *ngIf="item.options.length > 0 || item.themes.length > 0 || item.masterFile">+</small>
                </button>
                <button mat-flat-button *ngFor="let item of shortCutsHistory"
                  [color]="item?.historic ? 'primary' : 'accent'"
                  matTooltipClass="multiline-tooltip"
                  [matTooltip]="getTooltip(item)"
                  [disabled]="disableControls"
                  (click)="loadShortCuts(item)">
                    {{item.home}}
                    <small *ngIf="item.options.length > 0 || item.themes.length > 0 || item.masterFile">+</small>
                </button>
              </div>
            </div>
          <hr />
            <div class="title w-100" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="start center">
              <mat-card-title>
                Home Configuration
              </mat-card-title>
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                <mat-form-field *ngIf="isSituUser">
                  <mat-label>Renderer</mat-label>
                  <mat-select (selectionChange)="selectRenderer($event.value)" [value]="selectedRenderer" [disabled]="disableControls">
                    <mat-option value="">Any</mat-option>
                    <mat-option *ngFor="let renderer of renderers" [value]="renderer">
                      {{renderer}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-checkbox *ngIf="false" [(ngModel)]="forceRefresh" [disabled]="disableForceRefresh"
                  matTooltip="Due to system changes, 'Force Refresh' has been made redundant and will be discontinued soon.">
                  Force Refresh
                </mat-checkbox>
                <button mat-flat-button color="primary" (click)="loadHome(true)" matTooltip="Render Home" style="min-width: fit-content;"
                [disabled]="(!this.selectedHomeConfig) || (!this.selectedHomeConfig?.masterFile) || (this.selectedHomeConfig?.themes?.length == 0 || disableControls)">
                  <mat-icon>done</mat-icon>
                  Render Home
                </button>
                <button *ngIf="isAdmin || isSituUser" mat-flat-button color="accent" (click)="queueHome()" matTooltip="Add to Priority Home Queue" [disabled]="(!this.selectedHomeConfig) || (!this.selectedHomeConfig?.masterFile) || (this.selectedHomeConfig?.themes?.length == 0 || disableControls)">
                  <mat-icon class="white-icon">queue</mat-icon>
                </button>
                <situ-furnish-menu *ngIf="isFurnishUser" [company]="company" [home]="selectedHomeConfig?.home" (selectedHomeIfcFileId)="onSelectedHomeIfcFileId($event)">
                  <button mat-flat-button color="accent" matTooltip="Furnish Home">
                    <mat-icon class="white-icon">chair</mat-icon>
                  </button>
                </situ-furnish-menu>
                <button *ngIf="artifactId" mat-flat-button color="accent" (click)="shareHome()" matTooltip="Share Home">
                  <mat-icon class="white-icon">share</mat-icon>
                </button>
              </div>
            </div>
            <div class="w-100" fxLayout="row" fxLayoutAlign="space-between enter">
              <div fxFlex="48">
                <mat-form-field>
                  <mat-label>Environment</mat-label>
                  <mat-select (selectionChange)="selectEnvironment($event.value)" [value]="selectedHomeConfig?.environment" [disabled]="disableControls">
                    <mat-option [value]="2"> Production </mat-option>
                    <mat-option [value]="1"> Staging </mat-option>
                    <mat-option [value]="3"> Fallback </mat-option>
                    <mat-option [value]="0"> Latest </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="48">
                <mat-form-field>
                  <mat-label>Render Type</mat-label>
                  <mat-select (selectionChange)="selectRenderType($event.value)" [value]="selectedHomeConfig?.render" [disabled]="disableControls">
                    <mat-option [value]="2"> Best Available </mat-option>
                    <mat-option [value]="0"> Standard </mat-option>
                    <mat-option *ngIf="isSituUser" [value]="1"> Photo Realistic </mat-option>
                    <mat-option *ngIf="isSituUser" [value]="11"> Photo Realistic + </mat-option>
                    <mat-option *ngIf="isSituUser" [value]="3"> Virtual Reality </mat-option>
                    <mat-option [value]="7"> Insights </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="w-100" fxLayout="row" fxLayoutAlign="space-between enter">
              <div fxFlex="48">
                <mat-form-field>
                  <mat-label>Home</mat-label>
                  <mat-select (selectionChange)="selectHome($event.value)" [value]="selectedHomeConfig?.home" [disabled]="disableControls">
                    <mat-option *ngFor="let item of homes" [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="48">
                <mat-form-field>
                  <mat-label>Master File</mat-label>
                  <mat-select (selectionChange)="selectMasterFile($event.value)" [value]="selectedHomeConfig?.masterFile" [disabled]="disableControls">
                    <mat-option *ngFor="let item of masterFiles" [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <hr>
            <div class="w-100" fxLayout="row" fxLayoutAlign="space-between enter">
              <div fxFlex="48" fxLayout="column" fxLayoutAlign="start start" [ngClass.lt-sm]="{'m-b-20': true}">
                <mat-card-title class="m-b-20">Options</mat-card-title>
                <div class="options-list">
                  <mat-slide-toggle *ngFor="let option of options" [(ngModel)]="option.selected" (change)="toggleOption($event, option)" [disabled]="disableControls" [matTooltip]="option.name">
                    {{option.name}}
                  </mat-slide-toggle>
                </div>
                <!-- <div>
                  <div>selected: {{ selectedHomeConfig | json }}</div>
                </div> -->
              </div>
              <div fxFlex="48" class="w-100" fxLayout="column" fxLayoutAlign="start start">
                <div class="title m-b-10 w-100" fxLayout="column" fxLayoutAlign="start start">
                  <div class="m-b-20 w-100" fxLayout="row" fxLayoutAlign="space-between start">
                    <mat-card-title>Themes</mat-card-title>
                    <button mat-stroked-button color="basic" *ngIf="selectedHomeConfig?.themes?.length > 0" [disabled]="disableControls"
                      (click)="clearThemes()">
                      <mat-icon>clear</mat-icon> Clear
                    </button>
                  </div>
                  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <p>Legend</p>
                    <button class="m-b-5" color="basic" mat-flat-button [disabled]="disableControls"
                      matTooltip="Replaces fixtures in the home, like ovens, cooktops, and surfaces like paints, tiles, bricks with high resolution manufacturers' products.">Theme</button>
                    <button class="m-b-5" color="primary" mat-flat-button [disabled]="disableControls"
                      matTooltip="Used to apply materials to the home. Include things like paints, tiles, bricks, benchtop colours etc.">Decorator</button>
                    <button class="m-b-5" color="accent" mat-flat-button [disabled]="disableControls"
                      matTooltip="After the placement of the furnishings is determined, the furniture theme is then used to set what style of beds, tables, sofas, tv's etc are to be placed.">Furnishing</button>
                    <button class="m-b-5" color="warn" mat-flat-button [disabled]="disableControls"
                      matTooltip="Determining the positions of furniture to be placed in the home. It decides how and where to place things like beds, tables, desks, right down to items like toasters and kettles.">Furnishing Placement Schemes</button>
                    <button class="m-b-5" color="basic" mat-flat-button [disabled]="disableControls"
                      matTooltip="Replaces fixtures in the home, like ovens, cooktops, sinks, basins, taps with high resolution manufacturers' products.">Product Replacement</button>
                    <button class="m-b-5" color="basic" mat-flat-button [disabled]="disableControls"
                      matTooltip="Parameter themes"><span class="text-info">Parameter</span></button>
                  </div>
                </div>
                <p>Selected Themes</p>
                <div fxLayout="row wrap" fxLayoutGap="5px">
                  <ng-container *ngFor="let item of selectedHomeConfig?.themes">
                    <span [class]="getThemeColor(getTheme(item), true)">{{ item }}</span>
                    <div>&nbsp;>&nbsp;</div>
                  </ng-container>
                </div>
                <span *ngIf="selectedHomeConfig?.themes?.length == 0" class="text-warning m-b-20">You must select a theme.</span>
                <hr>
                <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <button 
                    class="m-b-5"
                    mat-flat-button
                    *ngFor="let item of themes"
                    (click)="toggleTheme(item)"
                    [ngClass]="{'selected-theme': item.selected}"
                    [color]="getThemeColor(item, false)"
                    [disabled]="disableControls">
                    <span [class.text-info]="item.type === 5">{{item.name}}</span>
                  </button>
                </div>
              </div>
            </div>            
          </div>
        </div>
      </mat-tab>
      <mat-tab [disabled]="disableControls">
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">map</mat-icon>
          Floor Plan
        </ng-template>

        <ng-template matTabContent>
          <!--TODO-->
          <div class="p-t-20">
            <div class="floorplan-tab-container">
              <div [hidden]="floorPlansAvailable.indexOf('GROUND') == -1">
                <label>
                  Ground
                </label>
                <app-floor-plan [interactive]="true" [floor]="'GROUND'" [onPluginManagerLoad]="pluginManagerLoaded"
                  [floorplanSettings]="largeFloorplanSettings" [interactive]="floorplanInteractive">
                </app-floor-plan>
              </div>

              <div [hidden]="floorPlansAvailable.indexOf('FIRST') == -1">
                <label>
                  First
                </label>
                <app-floor-plan [interactive]="true" [floor]="'FIRST'" [onPluginManagerLoad]="pluginManagerLoaded"
                  [floorplanSettings]="largeFloorplanSettings" [interactive]="floorplanInteractive">
                </app-floor-plan>
              </div>

              <div [hidden]="floorPlansAvailable.indexOf('SECOND') == -1">
                <label>
                  Second
                </label>
                <app-floor-plan [interactive]="true" [floor]="'SECOND'" [onPluginManagerLoad]="pluginManagerLoaded"
                  [floorplanSettings]="largeFloorplanSettings" [interactive]="floorplanInteractive">
                </app-floor-plan>
              </div>

              <div *ngIf="!floorPlansAvailable.length">
                No floorplan to display.
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab [disabled]="disableControls">
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">settings</mat-icon>
          Settings
        </ng-template>
        <mat-card-title>
          <div class="p-t-20">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>
                Home
              </div>
              <div class="right-align">
                <button mat-flat-button color="primary" (click)="loadHome(true)">
                  <mat-icon>done</mat-icon> Apply
                </button>
              </div>
            </div>
          </div>
        </mat-card-title>

        <app-home-config-settings [onPluginManagerLoad]="pluginManagerLoaded" (hideControls)="setHideControls($event)"
          [(floorplanSettings)]="floorplanSettings" [(floorPlanInteractive)]="floorplanInteractive">
        </app-home-config-settings>
      </mat-tab>

      <mat-tab [disabled]="disableControls">
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">terminal</mat-icon>
          Console
        </ng-template>
        <div fxLayout="column" class="p-t-20">
          <mat-card-title>
            Event Outputs
          </mat-card-title>
          <div class="title">
            <div class="right-align">
              <mat-checkbox [(ngModel)]="advancedEnabled">
                Show Advanced Controls on Viewer
              </mat-checkbox>
            </div>
          </div>
          <div id="console">
            <div class="scroller" id="consoleScroll">
              <div *ngFor="let item of outputs"> {{item}} </div>
            </div>
          </div>
          <div class="console-clear">
            <button mat-stroked-button (click)="outputs = []" color="basic">
              <mat-icon>clear</mat-icon> Clear
            </button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>


